<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="transparent">
        <v-toolbar-title>Activacion Ciudadana</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="abrirNuevo()">Nueva Activacion</v-btn>
        <v-spacer></v-spacer>
        <v-select
          v-model="filterEstado"
          :items="estadoOptions"
          item-text="text"
          item-value="value"
          label="Estado"
          clearable
          hide-details
          dense
          style="max-width: 180px;"
          class="mr-3"
        ></v-select>
        <v-text-field
          class="text-xs-center"
          v-model="search"
          append-icon="search"
          label="Busqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="filteredActivations"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:item.tipo="{ item }">
          <v-chip small outlined>{{ tipoLabel(item.tipo) }}</v-chip>
        </template>
        <template v-slot:item.estado="{ item }">
          <v-chip small :color="estadoColor(item.estado)" dark>{{ item.estado }}</v-chip>
        </template>
        <template v-slot:item.prioridad="{ item }">
          <v-chip small :color="prioridadColor(item.prioridad)" dark>{{ item.prioridad }}</v-chip>
        </template>
        <template v-slot:item.audiencia="{ item }">
          <v-chip small outlined>{{ item.audiencia }}</v-chip>
        </template>
        <template v-slot:item.fechaInicio="{ item }">
          {{ item.fechaInicio ? formatDate(item.fechaInicio) : '' }}
        </template>
        <template v-slot:item.opciones="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="editarItem(item)">edit</v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="cambiarEstado(item)">swap_horiz</v-icon>
            </template>
            <span>Cambiar estado</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on" @click="confirmarEliminar(item)">delete</v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getActivations()">Resetear</v-btn>
        </template>
      </v-data-table>

      <!-- Modal Crear/Editar -->
      <v-dialog v-model="formModal" max-width="800">
        <v-card>
          <v-card-title class="headline primary white--text">
            {{ editando ? 'Editar Activacion' : 'Nueva Activacion' }}
          </v-card-title>
          <v-card-text class="pt-4">
            <v-layout row wrap>
              <v-flex xs12 class="pa-2">
                <v-text-field v-model="form.titulo" label="Titulo *" required></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-2">
                <v-text-field v-model="form.consigna" label="Consigna *" required></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-2">
                <v-textarea v-model="form.descripcion" label="Descripcion" rows="3"></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select v-model="form.tipo" :items="tipoOptions" label="Tipo"></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select v-model="form.audiencia" :items="audienciaOptions" label="Audiencia"></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select v-model="form.prioridad" :items="prioridadOptions" label="Prioridad"></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-select v-model="form.estado" :items="estadoAllOptions" label="Estado"></v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.fechaInicio" label="Fecha Inicio" type="date"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pa-2">
                <v-text-field v-model="form.fechaCierre" label="Fecha Cierre" type="date"></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-2">
                <v-text-field v-model="form.hashtags" label="Hashtags (separados por coma)"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="formModal = false">Cancelar</v-btn>
            <v-btn color="primary" @click="guardar" :disabled="!form.titulo || !form.consigna">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal Cambiar Estado -->
      <v-dialog v-model="estadoModal" max-width="400">
        <v-card>
          <v-card-title class="headline primary white--text">Cambiar Estado</v-card-title>
          <v-card-text class="pt-4">
            <v-select v-model="nuevoEstado" :items="estadoAllOptions" label="Nuevo estado"></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="estadoModal = false">Cancelar</v-btn>
            <v-btn color="primary" @click="guardarEstado">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal Eliminar -->
      <v-dialog v-model="deleteModal" max-width="400">
        <v-card>
          <v-card-title class="headline">Confirmar eliminacion</v-card-title>
          <v-card-text>
            Estas seguro de que deseas eliminar <strong>{{ itemToDelete ? itemToDelete.titulo : '' }}</strong>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteModal = false">Cancelar</v-btn>
            <v-btn color="red" dark @click="eliminar">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      search: "",
      filterEstado: "",
      formModal: false,
      deleteModal: false,
      estadoModal: false,
      editando: false,
      form: {},
      itemToDelete: null,
      itemEstado: null,
      nuevoEstado: "",
      tipoOptions: ["REDES_SOCIALES", "PRESENCIAL", "TELEFONICA", "MIXTA"],
      audienciaOptions: ["AFILIADOS", "SIMPATIZANTES", "TODOS"],
      prioridadOptions: ["ALTA", "MEDIA", "BAJA"],
      estadoAllOptions: ["PENDIENTE", "ACTIVA", "COMPLETADA", "CANCELADA"],
      estadoOptions: [
        { text: "Todos", value: "" },
        { text: "Pendiente", value: "PENDIENTE" },
        { text: "Activa", value: "ACTIVA" },
        { text: "Completada", value: "COMPLETADA" },
        { text: "Cancelada", value: "CANCELADA" },
      ],
      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Titulo", value: "titulo", sortable: true },
        { text: "Tipo", value: "tipo", sortable: true },
        { text: "Audiencia", value: "audiencia", sortable: true },
        { text: "Prioridad", value: "prioridad", sortable: true },
        { text: "Estado", value: "estado", sortable: true },
        { text: "Fecha Inicio", value: "fechaInicio", sortable: true },
      ],
    };
  },
  created() {
    this.getActivations();
  },
  computed: {
    ...mapState("citizenActivationNamespace", ["activations"]),
    filteredActivations() {
      if (!this.filterEstado) return this.activations;
      return this.activations.filter(a => a.estado === this.filterEstado);
    },
  },
  methods: {
    ...mapActions("citizenActivationNamespace", [
      "getActivations", "saveActivation", "updateActivation",
      "changeEstado", "deleteActivation"
    ]),
    abrirNuevo() {
      this.editando = false;
      this.form = {
        titulo: "", consigna: "", descripcion: "",
        tipo: "REDES_SOCIALES", audiencia: "TODOS",
        prioridad: "MEDIA", estado: "PENDIENTE",
        fechaInicio: "", fechaCierre: "", hashtags: ""
      };
      this.formModal = true;
    },
    editarItem(item) {
      this.editando = true;
      this.form = { ...item };
      if (this.form.fechaInicio) this.form.fechaInicio = this.form.fechaInicio.substring(0, 10);
      if (this.form.fechaCierre) this.form.fechaCierre = this.form.fechaCierre.substring(0, 10);
      this.formModal = true;
    },
    async guardar() {
      if (this.editando) {
        await this.updateActivation(this.form);
      } else {
        await this.saveActivation(this.form);
      }
      this.formModal = false;
    },
    cambiarEstado(item) {
      this.itemEstado = item;
      this.nuevoEstado = item.estado;
      this.estadoModal = true;
    },
    async guardarEstado() {
      await this.changeEstado({ id: this.itemEstado._id, estado: this.nuevoEstado });
      this.estadoModal = false;
    },
    confirmarEliminar(item) {
      this.itemToDelete = item;
      this.deleteModal = true;
    },
    async eliminar() {
      await this.deleteActivation(this.itemToDelete._id);
      this.deleteModal = false;
      this.itemToDelete = null;
    },
    tipoLabel(tipo) {
      const labels = { REDES_SOCIALES: "Redes Sociales", PRESENCIAL: "Presencial", TELEFONICA: "Telefonica", MIXTA: "Mixta" };
      return labels[tipo] || tipo;
    },
    estadoColor(estado) {
      const colors = { PENDIENTE: "orange", ACTIVA: "green", COMPLETADA: "blue", CANCELADA: "red" };
      return colors[estado] || "grey";
    },
    prioridadColor(prioridad) {
      const colors = { ALTA: "red", MEDIA: "orange", BAJA: "green" };
      return colors[prioridad] || "grey";
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
